import styled from '@emotion/styled';
import { Modal, ModalProps } from 'antd';
import { noop } from 'lodash-es';
import { useMemo } from 'react';
import { useTranslate } from '@tolgee/react';
import ItemSelectForm from './ItemSelectForm';

const Container = styled.div`
  margin: -14px;
`;

export interface ItemSelectModalProps extends ModalProps {
  platform: General.PlatformUpperCase;
  region: General.UpperCaseRegion;
  stores: Marketing.TaskStore[];
  value: Aide.SelectedItem[];
  skuEnable?: boolean;
  onChange: (value: any) => void;
}

function ItemSelectModal(props: ItemSelectModalProps) {
  const {
    platform,
    region,
    stores,
    value,
    skuEnable,
    onChange,
    onCancel = noop,
    ...otherProps
  } = props;

  const { t } = useTranslate();

  const initialValues = useMemo(() => {
    return {
      platform,
      region,
      stores,
      selectedItems: value,
      skuEnable,
      selectFlag: 0,
    };
  }, [platform, region, stores, value, skuEnable]);

  return (
    <ItemSelectForm
      initialValues={initialValues}
      onSubmit={({ selectedItems }, helpers) => {
        onChange(selectedItems);

        helpers.resetForm();
      }}
    >
      {(form, formProps) => {
        const { handleSubmit } = formProps;

        return (
          <Modal
            title={t('aide.选择商品')}
            width={790}
            onCancel={onCancel}
            okText={t('department.确认选择')}
            onOk={() => {
              handleSubmit();

              onCancel();
            }}
            {...otherProps}
          >
            <Container>{form}</Container>
          </Modal>
        );
      }}
    </ItemSelectForm>
  );
}

export default ItemSelectModal;
